var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8601 4.65277L11.5268 0.152826C11.3854 0.00622088 11.1688 -0.0397991 10.9802 0.0361277C10.7908 0.112787 10.6668 0.296134 10.6668 0.500111V2.66683H10.5002C6.91623 2.66683 4.00024 5.58281 4.00024 9.16675V10.1667C4.00024 10.3987 4.16357 10.592 4.38952 10.6448C4.42627 10.654 4.46289 10.6581 4.49951 10.6581C4.68823 10.6581 4.86889 10.5474 4.95617 10.3734C5.89354 8.49806 7.77816 7.3334 9.87483 7.3334H10.6668V9.5C10.6668 9.7041 10.7908 9.88745 10.9802 9.96338C11.1675 10.04 11.3854 9.9934 11.5268 9.84668L15.8601 5.34673C16.0468 5.15276 16.0468 4.84747 15.8601 4.65277Z",
    fill: "#03606A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 15.9999H2.00022C0.897572 15.9999 0.000244141 15.1027 0.000244141 14V4.66682C0.000244141 3.56417 0.897572 2.66684 2.00022 2.66684H4.0002C4.36884 2.66684 4.66681 2.96481 4.66681 3.33346C4.66681 3.70211 4.36884 4.00008 4.0002 4.00008H2.00022C1.63218 4.00008 1.33348 4.29878 1.33348 4.66682V14C1.33348 14.368 1.63218 14.6667 2.00022 14.6667H14.0001C14.368 14.6667 14.6667 14.368 14.6667 14V8.66678C14.6667 8.29813 14.9647 8.00003 15.3333 8.00003C15.7021 8.00003 16 8.29813 16 8.66678V14C16 15.1027 15.1027 15.9999 14.0001 15.9999Z",
    fill: "#03606A"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.7acc7e7a.svg";
export { ForwardRef as ReactComponent };